module.exports = __webpack_public_path__ + "img/power_point_logo.c4fb58a9.png";